import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { User } from "@supabase/supabase-js";

export interface AppUser extends User {
  username?: string;
  display_name?: string;
  avatar_url?: string;
}

interface AuthState {
  user: AppUser | null;
  loading: boolean;
  profileLoaded: boolean; // Track if profile fetch has completed
}

const initialState: AuthState = {
  user: null,
  loading: false,
  profileLoaded: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<AppUser>) => {
      state.user = action.payload;
      state.loading = false;
      // If user has username, profile is loaded. Otherwise, keep current state
      if (action.payload.username !== undefined) {
        state.profileLoaded = true;
      }
    },
    clearUser: (state) => {
      state.user = null;
      state.loading = false;
      state.profileLoaded = false;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setProfileLoaded: (state, action: PayloadAction<boolean>) => {
      state.profileLoaded = action.payload;
    },
  },
});

export const { setUser, clearUser, setLoading, setProfileLoaded } = authSlice.actions;
export default authSlice.reducer;
